import Vue from 'vue'

const state = {
    family: {
        my: {
            addProject: {
                title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_0"),
                popLabel: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_1"),
                describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_2")
            },
            delete: {
                _id: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_3"), },
                projectId: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_4"), }
            },
        }
    },
    teacher: {
        my: {
            addProject: {
                title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_5"),
                popLabel: '',
                describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_6")
            },
            delete: {
                _id: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_7"), describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_8") },
                projectId: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_9"),  }
            },
        },
        shared: {
            addProject: {
                title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_10"),
                popLabel: '',
                describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_11")
            },
            delete: {
                _id: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_12"), describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_13") },
                projectId: { title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_14"), describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_15") }
            }
        },
        
        sharedPop: {
            private2Shared: {
                _id: {
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_16"), },
                    describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_17")
                },
                projectId: {
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_18"), },
                    describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_19")
                }
            },
            shared2Private: {
                _id: {
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_20"), },
                    describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_21")
                },
                projectId: {
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_22"), },
                    describe: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_23")
                }
            },
            shared2Shared: {
                _id: {
                    hsName: 'name$',
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_24"), },
                    describe: [Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_25"), Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_26")]
                },
                projectId: {
                    hsName: 'name$',
                    dialog: {  title: Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_27"), },
                    describe: [Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_28"), Vue.prototype.$t("code-lab/component/file-management/observable/fileCrudMapOber.js_29")]
                }
            },
        }
    },
}

export const store = Vue.observable(state)

export const mutations = {}


